import React, { useState } from "react";
import axios from "axios";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "./AddGuppyScreen.css";
import AdminAppBar from "./AdminAppBar";

const AddFoodScreen = () => {
  const [newFood, setNewFood] = useState({
    name: "",
    flakesPrice: "",
    powderPrice: "",
    flakesQuantity: "",
    powderQuantity: "",
    sold_status: false,
    image: null,
  });
  const [error, setError] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 50000000) {
        setError("File size should not exceed 50MB");
      } else if (!file.type.startsWith("image/")) {
        setError("Only image files are allowed.");
      } else {
        setError("");
        setNewFood((prev) => ({ ...prev, image: file }));
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewFood((prev) => ({ ...prev, [name]: value }));
  };

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);
    const uploadUrl = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

    try {
      const response = await axios.post(uploadUrl, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        },
      });
      return response.data.secure_url;
    } catch (error) {
      console.error("Upload Error:", error);
      alert("Failed to upload image.");
      return null;
    }
  };

  const handleUpload = async () => {
    if (error) return alert(error);

    // Validation
    if (!newFood.name.trim()) {
      return alert("اسم الطعام مطلوب");
    }

    // At least one type must have price and quantity
    const hasFlakes = newFood.flakesPrice && parseFloat(newFood.flakesPrice) > 0 &&
      newFood.flakesQuantity && parseInt(newFood.flakesQuantity) >= 0;
    const hasPowder = newFood.powderPrice && parseFloat(newFood.powderPrice) > 0 &&
      newFood.powderQuantity && parseInt(newFood.powderQuantity) >= 0;

    if (!hasFlakes && !hasPowder) {
      return alert("يجب إدخال سعر وكمية على الأقل لنوع واحد (رقائق أو مسحوق)");
    }

    setUploadProgress(0);
    try {
      let imageUrl = null;
      if (newFood.image) {
        imageUrl = await uploadToCloudinary(newFood.image);
      }

      const foodData = {
        name: newFood.name,
        flakesPrice: parseFloat(newFood.flakesPrice || 0),
        powderPrice: parseFloat(newFood.powderPrice || 0),
        flakesQuantity: parseInt(newFood.flakesQuantity || 0, 10),
        powderQuantity: parseInt(newFood.powderQuantity || 0, 10),
        sold_status: newFood.sold_status,
        image: imageUrl,
      };

      const foodCollection = collection(db, "food");
      await addDoc(foodCollection, foodData);

      try {
        const webhookUrl = process.env.REACT_APP_N8N_ADD_PRODUCT_WEBHOOK_URL || process.env.REACT_APP_N8N_ADD_GUPPY_WEBHOOK_URL;
        if (webhookUrl) {
          const response = await fetch(webhookUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ...foodData, itemType: "food" }),
          });

          if (!response.ok) {
            console.error("n8n Webhook Error. Status:", response.status);
            alert("✅ تم حفظ الطعام في المتجر\n❌ تأكد من تفعيل Workflow في n8n، لم يتم النشر على فيسبوك!");
          } else {
            console.log("Food info sent to n8n webhook successfully");
            alert("✅ تم إضافة الطعام بنجاح!\n✅ تم نشره على صفحة فيسبوك تلقائياً!");
          }
        } else {
          alert("✅ تم حفظ الطعام في المتجر");
        }
      } catch (webhookError) {
        console.error("Failed to send food info to n8n webhook:", webhookError);
        alert("✅ تم حفظ الطعام في المتجر\n❌ حدث خطأ في الاتصال بسيرفر n8n للمنشورات!");
      }

      // Reset form
      setNewFood({
        name: "",
        flakesPrice: "",
        powderPrice: "",
        flakesQuantity: "",
        powderQuantity: "",
        sold_status: false,
        image: null,
      });
      setUploadProgress(0);

      // Reset file input by changing the key
      setFileInputKey(Date.now());

    } catch (err) {
      console.error("Upload Error:", err);
      alert("فشل رفع الطعام.");
    }
  };

  return (
    <div>
      <AdminAppBar />
      <div className="page-container">
        <h1 className="title">إضافة طعام أسماك</h1>
        {error && <p className="error-message">{error}</p>}
        <div className="input-card">
          <label className="label">صورة الطعام</label>
          <input key={fileInputKey} type="file" accept="image/*" onChange={handleFileChange} className="input-field" />

          <label className="label">اسم الطعام (Name)</label>
          <input
            type="text"
            name="name"
            value={newFood.name}
            onChange={handleInputChange}
            className="input-field"
            placeholder="أدخل اسم الطعام"
          />

          {/* Flakes Section */}
          <div style={{
            background: "rgba(249, 115, 22, 0.1)",
            border: "1px solid rgba(249, 115, 22, 0.3)",
            borderRadius: "12px",
            padding: "16px",
            marginBottom: "16px"
          }}>
            <h3 style={{ color: "#f97316", marginBottom: "12px", fontSize: "18px" }}>
              رقائق (Flakes) 🍽️
            </h3>

            <label className="label">سعر الرقائق (Flakes Price)</label>
            <input
              type="number"
              name="flakesPrice"
              value={newFood.flakesPrice}
              onChange={handleInputChange}
              className="input-field"
              placeholder="أدخل السعر بالدينار الجزائري"
              min="0"
              step="0.01"
            />

            <label className="label">كمية الرقائق (Flakes Quantity)</label>
            <input
              type="number"
              name="flakesQuantity"
              value={newFood.flakesQuantity}
              onChange={handleInputChange}
              className="input-field"
              placeholder="أدخل الكمية المتاحة"
              min="0"
            />
          </div>

          {/* Powder Section */}
          <div style={{
            background: "rgba(249, 115, 22, 0.1)",
            border: "1px solid rgba(249, 115, 22, 0.3)",
            borderRadius: "12px",
            padding: "16px",
            marginBottom: "16px"
          }}>
            <h3 style={{ color: "#f97316", marginBottom: "12px", fontSize: "18px" }}>
              مسحوق (Powder) 🥄
            </h3>

            <label className="label">سعر المسحوق (Powder Price)</label>
            <input
              type="number"
              name="powderPrice"
              value={newFood.powderPrice}
              onChange={handleInputChange}
              className="input-field"
              placeholder="أدخل السعر بالدينار الجزائري"
              min="0"
              step="0.01"
            />

            <label className="label">كمية المسحوق (Powder Quantity)</label>
            <input
              type="number"
              name="powderQuantity"
              value={newFood.powderQuantity}
              onChange={handleInputChange}
              className="input-field"
              placeholder="أدخل الكمية المتاحة"
              min="0"
            />
          </div>

          <div className="checkbox-container">
            <label className="label">حالة البيع (Sold Status)</label>
            <input
              type="checkbox"
              checked={newFood.sold_status}
              onChange={(e) => setNewFood({ ...newFood, sold_status: e.target.checked })}
              className="checkbox-field"
            />
            <span>{newFood.sold_status ? "تم البيع (Sold)" : "متاح (Available)"}</span>
          </div>

          <button onClick={handleUpload} className="upload-button">
            رفع الطعام
          </button>

          {uploadProgress > 0 && (
            <div className="progress-container">
              <div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div>
              <span className="progress-text">{uploadProgress}%</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddFoodScreen;

